var valueReducerGen = function valueReducerGen(args) {
  var isControlled = args.isControlled,
    onChange = args.onChange,
    dateValidator = args.dateValidator,
    selectRange = args.selectRange,
    minDate = args.minDate,
    maxDate = args.maxDate,
    disabledDays = args.disabledDays,
    disabledDates = args.disabledDates,
    disabledRanges = args.disabledRanges,
    momentUtils = args.momentUtils,
    _args$maxDetail = args.maxDetail,
    maxDetail = _args$maxDetail === void 0 ? 'month' : _args$maxDetail;
  var getStartDate = momentUtils.getStartDate,
    getEndDate = momentUtils.getEndDate;
  return function (state, action) {
    var _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload;
    var value = payload.value,
      notCallOnChange = payload.notCallOnChange;
    var isValidByRule = true;
    switch (action.type) {
      case 'setValue':
        var callbackValue = payload.value;
        isValidByRule = dateValidator.isValidDateValueByRules({
          date: value,
          minDate: minDate,
          maxDate: maxDate,
          disabledDays: disabledDays,
          disabledDates: disabledDates,
          disabledRanges: disabledRanges,
          maxDetail: maxDetail
        });
        if (value) {
          if (selectRange) {
            if (callbackValue instanceof Date) {
              callbackValue = [callbackValue];
            }
          }
        }
        //this callback is called after return,
        //so isValidByRule has been caculated
        var unit = 'day';
        if (maxDetail === 'year') {
          unit = 'month';
        }
        if (maxDetail === 'decade') {
          unit = 'year';
        }
        if (callbackValue instanceof Array) {
          callbackValue = callbackValue.map(function (v, k) {
            if (k === 0) {
              return getStartDate(v, unit);
            } else if (k === 1) {
              return getEndDate(v, unit);
            }
          });
        }
        setTimeout(function () {
          if (!notCallOnChange) onChange && onChange(callbackValue, isValidByRule);
        }, 0);
        if (isControlled) {
          return {
            value: state.value
          };
        } else {
          return {
            value: isValidByRule ? payload.value : null
          };
        }
      case 'setValueByProps':
        isValidByRule = dateValidator.isValidDateValueByRules({
          date: payload.value,
          minDate: minDate,
          maxDate: maxDate,
          disabledDays: disabledDays,
          disabledDates: disabledDates,
          disabledRanges: disabledRanges
        });
        onChange && onChange(payload.value, isValidByRule);
        return {
          value: payload.value
        };
      default:
        return {
          value: state.value
        };
    }
  };
};
export default valueReducerGen;